import * as React from "react";
import {cx}       from "emotion";

import "./header-mobile.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Select2}        from "@Common/ui-components/select-2/select-2";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {LoadingPanel}  from "@Xpresso/routes/common/loading-panel/loading-panel";
import {AGENT_LEVEL,
        BRANCH_LEVEL,
        COMPANY_LEVEL} from "@Xpresso/routes/common/logic/user-level";

import {mapFullNameAsInitials} from "../../../user-management-route/user-management-card/user-management-card";
import {UserManagementModal}   from "../../../user-management-route/user-management-modal/user-management-modal";

export const HeaderMobile = (
    {
        data: {loading, agent, user, reload,},
        activeTabLink, agentId, branchId, activeTab, items,
        navBlock,
    }
) => cs(
    consumeContext("routerHistory"),
    ["agentFullName", ({}, next) => next(agent &&
        [agent.agentNameFirst, agent.agentNameMiddle, agent.agentNameLast].filter(Boolean).join(" ")
    )],
    ["query", ({}, next) => next(parseUrlQuery(window.location.search))],
    ({query}, next) => UserManagementModal({
        initShow: query?.['modal'] === "manage",
        branchId,
        reload,
        next,
        baseUrl : activeTabLink,

    }),
    ({agentFullName, routerHistory}) => (
        <div className="header-mobile-4we">
            {loading ? (
                LoadingPanel({})
            ) : <>
                <div className="info">
                    <div className="headshot-section">
                        <div className={cx("headshot",{inactive: !agent.agentActive})}>
                            {agent?.imageGallery?.headshots[0]?.thumbnailUrl ? (
                                <img src={agent.imageGallery.headshots[0].thumbnailUrl} alt={agentFullName}/>
                            ) : (
                                <div className="headshot-placeholder">{mapFullNameAsInitials({agent: agent})}</div>
                            )}
                        </div>
                    </div>
                    <div className="name-section">
                        <div className="top">
                            <div className="name" xd-qa-type="label" xd-qa-name="Agent Full Name">
                                {agentFullName}
                            </div>
                            {/* <div
                                className="user-edit"
                                xd-qa-type="link"
                                xd-qa-name="Edit"
                                onClick={ ()=>
                                    routerHistory.replace(activeTabLink + '&modal=manage&menu=general')
                                }
                                >
                                    Edit
                            </div> */}
                        </div>

                        {(!agent.agentActive || (user.loginLevel !== AGENT_LEVEL)) && (
                            <div className="badges">
                                {user?.loginLevel === COMPANY_LEVEL ? (
                                    <div xd-qa-type="badge" xd-qa-name="Company Admin" className="badge company-admin-badge">Company Admin</div>
                                ) : user?.loginLevel === BRANCH_LEVEL && (
                                    <div xd-qa-type="badge" xd-qa-name="Office Admin" className="badge office-admin-badge">Office Admin</div>
                                )}

                                {!agent?.agentActive && <div xd-qa-type="badge" xd-qa-name="Inactive" className="badge inactive-badge">Inactive</div>}
                            </div>
                        )}
                    </div>
                </div>
                <div className="tab-selection">
                    {Select2<any>({
                        isSelected: (item) => activeTab === item.name,
                        getLabel: (item) => item.linkLabel,
                        onSelect: async (item) => {
                            if (await navBlock?.block() === true) {
                                return;
                            }

                            routerHistory.replace(item.link + buildUrlQuery({
                                ...agentId && {
                                    agent: agentId
                                },
                                ...branchId && {
                                    branch: branchId
                                },
                            }));
                        },
                        xdQaName: "Tab Dropdown",
                        className: "question",
                        list: items,
                        disableClearingSelection: true,
                    })}
                </div>
            </>}
        </div>
    ),
);
